(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('dac-content', {
            abstract: true,
            parent: 'app'
        })
        .state('dac-content-main', {
        	abstract: true,
        	parent: 'dac-content',
            url: '/dac-content-main',
            data: {
                authorities: ['Administrators', 'DAC Content Administrator', 'DAC Content User']
            },
            views: {
                'content@': {
                    templateUrl: 'app/dac-content/templates/dac-content.html',
                    controller: 'DacContentController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();
